/**
 * v-drag-over: adds the "drag-over" class to a file drop zone while a file
 * is being dragged over it, so the zone can visibly react (see the
 * `.drag-over` rules next to each drop zone's styles).
 *
 * dragenter/dragleave also fire when the pointer crosses the zone's own
 * children, so a depth counter keeps the class on until the pointer really
 * leaves the zone. Only file drags count (not dragged text or links).
 */
const CLASS = "drag-over";

function isFileDrag(e) {
  const types = e.dataTransfer && e.dataTransfer.types;
  return !!types && Array.prototype.indexOf.call(types, "Files") !== -1;
}

export default {
  bind(el) {
    let depth = 0;
    const enter = (e) => {
      if (!isFileDrag(e)) return;
      depth += 1;
      el.classList.add(CLASS);
    };
    const leave = (e) => {
      if (!isFileDrag(e)) return;
      depth = Math.max(0, depth - 1);
      if (depth === 0) el.classList.remove(CLASS);
    };
    const reset = () => {
      depth = 0;
      el.classList.remove(CLASS);
    };
    el._dragOver = { enter, leave, reset };
    el.addEventListener("dragenter", enter);
    el.addEventListener("dragleave", leave);
    el.addEventListener("drop", reset);
  },
  unbind(el) {
    const handlers = el._dragOver;
    if (!handlers) return;
    el.removeEventListener("dragenter", handlers.enter);
    el.removeEventListener("dragleave", handlers.leave);
    el.removeEventListener("drop", handlers.reset);
    delete el._dragOver;
  },
};
